module.exports = __webpack_public_path__ + "1fc5324dd13115ffc7e4f57f0a5cc05d.svg";